import { Meta } from "@/modules/hrs/paysheets/types"

// Interface cho CashBook theo entity
export interface CashBook {
  id: string
  name: string
  from_date: string
  to_date: string
  opening_balance: number
  closing_balance?: number
  difference_amount?: number
  status: CashBookStatus
  created_by_id: number
  created_at: string
  closed_at?: string
  notes?: string
  created_by_name?: string
  total_income?: number
  total_expense?: number
  receipts?: any[]
}

// DTO cho tạo sổ quỹ
export interface CreateCashBookDto {
  name: string
  from_date: string // YYYY-MM-DD
  to_date: string   // YYYY-MM-DD
  opening_balance: number
  notes?: string
}

// DTO cho cập nhật sổ quỹ
export interface UpdateCashBookDto {
  name: string;
  from_date: string; // YYYY-MM-DD
  to_date: string;   // YYYY-MM-DD
  opening_balance: number;
  notes?: string;
}

// DTO cho chốt sổ quỹ
export interface CloseCashBookDto {
  closing_balance: number
  notes?: string
}

// Response chi tiết sổ quỹ
export interface CashBookDetailDto {
  id: string
  name: string
  from_date: string
  to_date: string
  opening_balance: number
  closing_balance?: number
  total_income: number
  total_expense: number
  difference_amount?: number
  status: CashBookStatus
  notes?: string
  created_by_name?: string
  created_at: string
  closed_at?: string
  receipts: any[]
}

// Data response với pagination
export interface CashBookData {
  items: CashBook[]
  meta: Meta
}

// Enum cho trạng thái
export enum CashBookStatus {
  ACTIVE = 'active',
  CLOSED = 'closed'
}

// Map cho hiển thị trạng thái
export const MAP_CASHBOOK_STATUS = {
  [CashBookStatus.ACTIVE]: "Đang mở",
  [CashBookStatus.CLOSED]: "Đã chốt sổ",
}
